$(document).on('click', '.logout_please', function(){
	incube_ajax('auth', 'json', 'logout', {}, function(){
		location.href = '/';
	});
});

//Клик по кнопке загрузки аватара. Перенаправляем на поле типа file.
$(document).on('click', '.edit_avatar', function(e) {
    e.preventDefault();
    $('#change_avatar').trigger('click');
});
//Загрузка нового аватара.
$(document).on('change', '#change_avatar', function(e) {
	e.stopPropagation();
    var formFile = new FormData();
    formFile.append('UserFile', $(this)[0].files[0]);
    incube_file_ajax('auth', 'json', 'change_avatar', formFile, function(response) {
        if(response['status'])
            $('.avatar_cont').each(function(){
            	var template = $(this).data('template');
            	$(this).find('img').attr(
            		'src', 
            		'/c/'+template+'/'+response['user']['avatar']['id']+'.'+response['user']['avatar']['file_type']
            	);
            });
        else
        	console.log(response['message']);
    });
});